<template>
    <rkm-overlay>
        <rkm-layout-body title="Recepção">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="hasPermissaoAtualizacaoCadastroPaciente"
                    @click="handleBuscarDadosPacienteIntegracaoCns"
                    color="info"
                >
                    Buscar dados do paciente no CADSUS
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <template
                v-if="paciente"
                v-slot:subtitle
            >

                <div class="sub-title">
                    <rkm-icon class="icon" icon="user"/>
                    <span class="text-uppercase" v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        {{ paciente.nome }} <strong>({{ paciente.nomeSocial }})</strong>,
                    </span>
                    <span class="text-uppercase" v-else>
                        {{ paciente.nome }},
                    </span>
                    <span v-if="paciente.idade">
                        {{ paciente.idade.anos }} anos,
                        {{ paciente.idade.meses }} meses
                        e {{ paciente.idade.dias }} dias,
                    </span>
                    <span>{{ paciente.sexo.descricao }}</span>
                </div>
            </template>

            <rkm-layout-content>
                <Form
                    :pacienteId="pacienteId"
                    :filaId="filaId"
                    :plantaoId="plantaoId"
                    :dataAtendimento="dataAtendimento"
                    ref="Form"
                    @save="handleSave"
                    @paciente="handlePaciente"
                    @loaded="loaded"
                />

                <ModalImpressao ref="ModalImpressao" />
            </rkm-layout-content>

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/pronto-atendimento/atendimento-recepcao/Form'
import ModalImpressao from '@/components/pronto-atendimento/impressao/components/impressao/Modal'
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Enums
import classificacao from '@/enums/cadastro/paciente/classificacao'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Mixins
import { unmask } from '@/mixins'

// Others
import moment from 'moment'

export default {
    components: {
        Form,
        ModalImpressao,
        ModalIntegracaoCns,
    },
    computed: {
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.cidadao && this.cidadao.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.cidadao && this.cidadao.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.cidadao && this.cidadao.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    methods: {
        loaded(value) {
            this.additionals = value.additionals
            this.cidadao = value.cidadao
        },
        handleExit() {
            this.showExitConfirmation(async () => {

                this.redirectToList()
            })
        },
        handleSave(data) {

            this.$refs.ModalImpressao.open(data.impressoes, data.atendimentoId, () => this.redirectToList())
        },
        redirectToList() {
            this.$router.push({ name: 'pronto-atendimento-atendimento-recepcao-index' }).catch(() => {})
        },
        handlePaciente(paciente) {

            this.paciente = paciente
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.cidadao.cidadaoId,
                nome: this.cidadao.nome,
                dataNascimento: this.cidadao.dataNascimento,
                nomeMae: this.cidadao.nomeMae,
                cns: this.cidadao.cns ? this.unMaskCns(this.cidadao.cns) : null,
                cpf: this.cidadao.cpf ? this.unMaskCpf(this.cidadao.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.cidadao, {
                ...item,
                dataNascimento: item.dataNascimento ? this.others.moment(item.dataNascimento).format('DD/MM/YYYY') : null
            })
        },
    },
    data: () => ({
        additionals: null,
        cidadao: null,
        enums: {classificacao, preferenciaNome},
        paciente: null,
        others: {moment},
    }),
    props: {
        pacienteId: { type: Number },
        filaId: { type: Number },
        plantaoId: { type: Number },
        dataAtendimento: { type: Date },
    },
    created() {

        if (!this.dataAtendimento) {

            this.redirectToList()
        }
    },
    mixins: [unmask],
}
</script>

<style scoped>
.sub-title {
    font-size: 13px;
    text-transform: uppercase;
    color: #222;
}
</style>